import { render, staticRenderFns } from "./NewAssignment.vue?vue&type=template&id=4c745be6&scoped=true&"
import script from "./NewAssignment.vue?vue&type=script&lang=ts&"
export * from "./NewAssignment.vue?vue&type=script&lang=ts&"
import style0 from "./NewAssignment.vue?vue&type=style&index=0&id=4c745be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c745be6",
  null
  
)

export default component.exports